export default "/images/a0dd40c7efdbcad102522ef456a1a467.png";